// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { notesStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsNotes";
import xOrderInformationStyles from "@turnerBlueprint/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { mergeWithCss } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

notesStyles.wrapper = {
    ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles?.wrapper, {
        css: css`
            flex-direction: column;
            margin-top: 4px;
            margin-bottom: 24px;
        `,
    }),
};

notesStyles.titleText = {
    ...xOrderInformationStyles.label,
};

notesStyles.notesText = {
    ...xOrderInformationStyles.note?.text,
};
